import type MessagePreviewOptionState from './schema/MessagePreviewOptionState';
import { createStore } from 'owa-satcheljs';

const defaultExport: () => MessagePreviewOptionState = createStore<MessagePreviewOptionState>(
    'messagePreviewOption',
    {
        showPreviewTextInListView: null,
    }
);
export default defaultExport;
